module.exports = __webpack_public_path__ + "img/podcasts_thumbnail.2b358cba.jpg";